module.exports = __webpack_public_path__ + "img/orgunits-icon-active.1d2072dc.svg";